export function useShowDialog(newDialogState: Dialog.DialogState): void {
    const dialogStore = useDialogStore()

    dialogStore.showDialog(newDialogState)
}

export function useShowDirtyDialog(onConfirm: Dialog.CallbackFunction, onCancel?: Dialog.CallbackFunction): void {
    useShowDialog({
        title: '¡Atención!',
        text: 'El documento tiene cambios sin guardar',
        confirmColor: 'red',
        confirmText: 'Descartar cambios',
        onConfirm,
        onCancel,
    })
}

export function useShowPersistentDirtyDialog(onConfirm: Dialog.CallbackFunction, onDeny: Dialog.CallbackFunction, onCancel?: Dialog.CallbackFunction): void {
    useShowDialog({
        title: '¡Atención!',
        text: 'El documento tiene cambios sin guardar',
        confirmColor: 'red',
        confirmText: 'Borrar',
        denyColor: 'yellow',
        denyText: 'Mantener en borrador',
        onConfirm,
        onDeny,
        onCancel,
    })
}

export function useShowConfirmDialog(onConfirm: Dialog.CallbackFunction, message: MaybeRefOrGetter<string> = 'Confirme para continuar'): void {
    useShowDialog({
        title: '¡Atención!',
        text: toValue(message),
        confirmColor: 'yellow',
        confirmText: 'Continuar',
        onConfirm,
    })
}

export function useShowDeleteDialog(onConfirm: Dialog.CallbackFunction, message: MaybeRefOrGetter<string> = 'Confirme para eliminar'): void {
    useShowDialog({
        title: '¡Atención!',
        text: toValue(message),
        confirmColor: 'red',
        confirmText: 'Eliminar',
        onConfirm,
    })
}

export function useShowResetDialog(onConfirm: Dialog.CallbackFunction, message: MaybeRefOrGetter<string> = 'Confirme para descartar'): void {
    useShowDialog({
        title: '¡Atención!',
        text: toValue(message),
        confirmColor: 'yellow',
        confirmText: 'Descartar',
        onConfirm,
    })
}

export function useShowErrorDialog(title: MaybeRefOrGetter<string>, message: MaybeRefOrGetter<string>, onConfirm?: Dialog.CallbackFunction): void {
    useShowDialog({
        title: toValue(title),
        text: toValue(message),
        confirmColor: 'red',
        noCancelButton: true,
        onConfirm,
    })
}
